import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { Styles } from "./styles/stickyMenu.js";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

function StickyMenu() {
  useEffect(() => {
    window.addEventListener("scroll", () => {
      const stickyMenu = document.querySelector(".sticky-menu");

      if (window.scrollY > 160) {
        stickyMenu.classList.add("sticky");
      } else {
        stickyMenu.classList.remove("sticky");
      }
    });
  });

  return (
    <Styles>
      {/* Sticky Menu */}
      <section className="sticky-menu">
        <Container>
          <Row>
            <Col md="3">
              <div className="d-flex align-items-center justify-content-between">
                <div className="logo">
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="tooltip1">Shri C. P. Radhakrishnan</Tooltip>
                    }
                  >
                    <Link to={process.env.PUBLIC_URL + "/"}>
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/Shri_C_P_ Radhakrishnan.jpg"
                        }
                        alt="Shri C. P. Radhakrishnan"
                      />
                    </Link>
                  </OverlayTrigger>
                </div>

                <div className="logo">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="tooltip2">Devendra Fadanvis</Tooltip>}
                  >
                    <Link to={process.env.PUBLIC_URL + "/"}>
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/Devendra_Fadanvis.png"
                        }
                        alt="Devendra Fadanvis"
                      />
                    </Link>
                  </OverlayTrigger>
                </div>

                <div className="logo">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="tooltip3">Eknath Shinde</Tooltip>}
                  >
                    <Link to={process.env.PUBLIC_URL + "/"}>
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/Eknath_Shinde.png"
                        }
                        alt="Eknath Shinde"
                      />
                    </Link>
                  </OverlayTrigger>
                </div>

                <div className="logo">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="tooltip4">Ajit Pawar</Tooltip>}
                  >
                    <Link to={process.env.PUBLIC_URL + "/"}>
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/ajit_pawar.png"
                        }
                        alt="Ajit Pawar"
                      />
                    </Link>
                  </OverlayTrigger>
                </div>
                
              </div>
            </Col>

            <Col md="9">
              <div className="menu-box d-flex justify-content-end">
                <ul className="nav menu-nav">
                  <li className="nav-item dropdown active">
                    <Link
                      className="nav-link dropdown-toggle"
                      to={process.env.PUBLIC_URL + "/"}
                      data-toggle="dropdown"
                    >
                      Home <i className="las la-angle-down"></i>
                    </Link>
                    <ul className="dropdown list-unstyled">
                      <li className="nav-item">
                        <Link
                          className="nav-link"
                          to={process.env.PUBLIC_URL + "/"}
                        >
                          Home Style 1
                        </Link>
                      </li>
                      <li className="nav-item active">
                        <Link
                          className="nav-link"
                          to={process.env.PUBLIC_URL + "/home-two"}
                        >
                          Home Style 2
                        </Link>
                      </li>
                    </ul>
                  </li>

                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle"
                      to={process.env.PUBLIC_URL + "/"}
                      data-toggle="dropdown"
                    >
                      Chancellor <i className="las la-angle-down"></i>
                    </Link>
                    <ul className="dropdown list-unstyled">
                      <li className="nav-item">
                        <Link
                          className="nav-link"
                          to={process.env.PUBLIC_URL + "/chancellor"}
                        >
                          About Chancellor of Public Universities of Maharashtra
                        </Link>
                      </li>
                    </ul>
                  </li>

                  {/* Pages with Nested Dropdown */}
                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle"
                      to={process.env.PUBLIC_URL + "/"}
                      data-toggle="dropdown"
                    >
                      Pages <i className="las la-angle-down"></i>
                    </Link>
                    <ul className="dropdown list-unstyled">
                      <li className="nav-item dropdown-submenu">
                        <Link
                          className="nav-link dropdown-toggle"
                          to={process.env.PUBLIC_URL + "/education"}
                          data-toggle="dropdown"
                        >
                          Law Education <i className="las la-angle-right"></i>
                        </Link>
                        <ul className="dropdown-submenu-list list-unstyled">
                          <li className="nav-item">
                            <Link
                              className="nav-link"
                              to={process.env.PUBLIC_URL + "/education/cet"}
                            >
                              CET
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              className="nav-link"
                              to={process.env.PUBLIC_URL + "/education/nri"}
                            >
                              NRI
                            </Link>
                          </li>
                        </ul>
                      </li>
                      <li className="nav-item dropdown-submenu">
                        <Link
                          className="nav-link dropdown-toggle"
                          to={process.env.PUBLIC_URL + "/college"}
                          data-toggle="dropdown"
                        >
                          Law Colleges <i className="las la-angle-right"></i>
                        </Link>
                        <ul className="dropdown-submenu-list list-unstyled">
                          <li className="nav-item">
                            <Link
                              className="nav-link"
                              to={process.env.PUBLIC_URL + "/college/mumbai"}
                            >
                              Mumbai Law Colleges
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              className="nav-link"
                              to={process.env.PUBLIC_URL + "/college/pune"}
                            >
                              Pune Law Colleges
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              className="nav-link"
                              to={process.env.PUBLIC_URL + "/college/nagpur"}
                            >
                              Nagpur Law Colleges
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              className="nav-link"
                              to={process.env.PUBLIC_URL + "/college/nashik"}
                            >
                              Nashik Law Colleges
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              className="nav-link"
                              to={
                                process.env.PUBLIC_URL + "/college/aurangabad"
                              }
                            >
                              Aurangabad Law Colleges
                            </Link>
                          </li>
                        </ul>
                      </li>
                      <li className="nav-item">
                        <Link
                          className="nav-link"
                          to={process.env.PUBLIC_URL + "/about"}
                        >
                          About Us
                        </Link>
                      </li>

                      <li className="nav-item">
                        <Link
                          className="nav-link"
                          to={process.env.PUBLIC_URL + "/contact"}
                        >
                          Contact
                        </Link>
                      </li>
                    </ul>
                  </li>

                  {/* Courses with Nested Dropdown */}
                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle"
                      to={process.env.PUBLIC_URL + "/"}
                      data-toggle="dropdown"
                    >
                      Courses <i className="las la-angle-down"></i>
                    </Link>
                    <ul className="dropdown list-unstyled">
                      <li className="nav-item dropdown-submenu">
                        <Link
                          className="nav-link dropdown-toggle"
                          to={process.env.PUBLIC_URL + "/course-grid"}
                          data-toggle="dropdown"
                        >
                          LAW PROGRAMS <i className="las la-angle-right"></i>
                        </Link>
                        <ul className="dropdown-submenu-list list-unstyled">
                          <li className="nav-item">
                            <Link
                              className="nav-link"
                              to={process.env.PUBLIC_URL + "/courses/ba-llb"}
                            >
                              BA LLB (5 Years)
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              className="nav-link"
                              to={process.env.PUBLIC_URL + "/courses/bba-llb"}
                            >
                              BBA LLB (5 Years)
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              className="nav-link"
                              to={process.env.PUBLIC_URL + "/courses/bcom-llb"}
                            >
                              B.Com LLB (5 Years)
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              className="nav-link"
                              to={process.env.PUBLIC_URL + "/courses/llb"}
                            >
                              LLB (3 Years)
                            </Link>
                          </li>
                        </ul>
                      </li>
                      {/* <li className="nav-item dropdown-submenu">
                        <Link
                          className="nav-link dropdown-toggle"
                          to={process.env.PUBLIC_URL + "/course-list"}
                          data-toggle="dropdown"
                        >
                          COURSE MATERIALS<i className="las la-angle-right"></i>
                        </Link>
                        <ul className="dropdown-submenu-list list-unstyled">
                          <li className="nav-item">
                            <Link
                              className="nav-link"
                              to={process.env.PUBLIC_URL + "/courses/llm"}
                            >
                              NOTES BY RENOWNED LECTURERS
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              className="nav-link"
                              to={
                                process.env.PUBLIC_URL + "/courses/llm-criminal"
                              }
                            >
                              READING MATERIALS
                            </Link>
                          </li>
                        </ul>
                      </li> */}
                    </ul>
                  </li>

                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle"
                      to={process.env.PUBLIC_URL + "/"}
                      data-toggle="dropdown"
                    >
                      COURSE MATERIALS <i className="las la-angle-down"></i>
                    </Link>
                    <ul className="dropdown list-unstyled">
                      <li className="nav-item">
                        <Link
                          className="nav-link"
                          to={process.env.PUBLIC_URL + "/courses/lecture"}
                        >
                          NOTES BY RENOWNED LECTURERS
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          className="nav-link"
                          to={process.env.PUBLIC_URL + "/courses/reading"}
                        >
                          READING MATERIALS
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle"
                      to={process.env.PUBLIC_URL + "/"}
                      data-toggle="dropdown"
                    >
                      Event <i className="las la-angle-down"></i>
                    </Link>
                    <ul className="dropdown list-unstyled">
                      <li className="nav-item">
                        <Link
                          className="nav-link"
                          to={process.env.PUBLIC_URL + "/events"}
                        >
                          Events
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          className="nav-link"
                          to={process.env.PUBLIC_URL + "/event-details"}
                        >
                          Event Details
                        </Link>
                      </li>
                    </ul>
                  </li>

                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle"
                      to={process.env.PUBLIC_URL + "/"}
                      data-toggle="dropdown"
                    >
                      Blog <i className="las la-angle-down"></i>
                    </Link>
                    <ul className="dropdown list-unstyled">
                      <li className="nav-item">
                        <Link
                          className="nav-link"
                          to={process.env.PUBLIC_URL + "/blog-classic"}
                        >
                          Blog Classic
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          className="nav-link"
                          to={process.env.PUBLIC_URL + "/blog-grid"}
                        >
                          Blog Grid
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          className="nav-link"
                          to={process.env.PUBLIC_URL + "/blog-details"}
                        >
                          Blog Details
                        </Link>
                      </li>
                    </ul>
                  </li>

                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle"
                      to={process.env.PUBLIC_URL + "/"}
                      data-toggle="dropdown"
                    >
                      Videos <i className="las la-angle-down"></i>
                    </Link>
                    <ul className="dropdown list-unstyled">
                      <li className="nav-item">
                        <Link
                          className="nav-link"
                          to={process.env.PUBLIC_URL + "/video"}
                        >
                          Videos
                        </Link>
                      </li>
                    </ul>
                  </li>
                </ul>

                <div className="apply-btn">
                  <Link to={process.env.PUBLIC_URL + "/registration"}>
                    <i className="las la-clipboard-list"></i>Apply Now
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </Styles>
  );
}

export default StickyMenu;
